export interface ChildParent {
  id: string
  childId: string
  name: string
  email: string
  phone: string | null
  relationship: string
  createdAt: string
}

// Valid weekdays for attendance schedules
export const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const
export type Weekday = typeof WEEKDAYS[number]

export const WEEKDAY_LABELS: Record<Weekday, string> = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
}

export interface Child {
  id: string
  childminderId: string
  firstName: string
  lastName: string
  dateOfBirth: string | null
  notes: string | null
  attendanceDays: string | null // Comma-separated list of weekdays
  photoUrl: string | null
  lockedAt: string | null
  isLocked: boolean
  createdAt: string
  updatedAt: string
  parents: ChildParent[]
}

// Helper to parse attendance days string to array
export function parseAttendanceDays(days: string | null): Weekday[] {
  if (!days) return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
  return days.split(',').filter(d => WEEKDAYS.includes(d as Weekday)) as Weekday[]
}

export interface SubscriptionInfo {
  tier: string
  limit: number
  used: number
  remaining: number | 'unlimited'
  lockedCount?: number
}

export interface ChildrenResponse {
  children: Child[]
  subscription: SubscriptionInfo
}

export interface CreateChildData {
  firstName: string
  lastName: string
  dateOfBirth?: string
  notes?: string
  attendanceDays?: Weekday[]
  parents?: {
    name: string
    email: string
    phone?: string
    relationship?: string
  }[]
}

export interface AddParentData {
  name: string
  email: string
  phone?: string
  relationship?: string
}
